export default __webpack_public_path__ + "static/media/robotArm.5f401e7f.jpg";